import Header from '@/components/Header';
import Footer from '@/components/Footer';

const PrivacyPolicy = () => {
  return (
    <>
      <Header />
      
      <section className="py-20 bg-white" data-testid="privacy-policy-page">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl font-bold mb-8">Privacy Policy</h1>
            <div className="mb-8"></div>

            <div className="space-y-8 text-gray-700 leading-relaxed">
              <section>
                <h2 className="text-3xl font-bold mb-4">1. Introduction</h2>
                <p>
                  Easy Trademark Filing ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">2. Information We Collect</h2>
                <p className="mb-4">
                  We collect information that you provide directly to us, including:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Name, email address, phone number, and other contact information</li>
                  <li>Business information including company name and industry</li>
                  <li>Trademark and intellectual property information</li>
                  <li>Payment and billing information</li>
                  <li>Communications and correspondence with us</li>
                </ul>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">3. How We Use Your Information</h2>
                <p className="mb-4">
                  We use the information we collect to:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Provide, maintain, and improve our services</li>
                  <li>Process your trademark and business formation applications</li>
                  <li>Communicate with you about our services</li>
                  <li>Send you updates, newsletters, and marketing communications</li>
                  <li>Respond to your comments, questions, and requests</li>
                  <li>Comply with legal obligations and protect our legal rights</li>
                </ul>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">4. Information Sharing and Disclosure</h2>
                <p>
                  We do not sell your personal information. We may share your information with:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4 mt-4">
                  <li>Government agencies (such as USPTO) as required for service delivery</li>
                  <li>Service providers who assist in our operations</li>
                  <li>Professional advisors including attorneys and accountants</li>
                  <li>Law enforcement when required by law</li>
                </ul>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">5. Data Security</h2>
                <p>
                  We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">6. Your Rights</h2>
                <p className="mb-4">
                  Depending on your location, you may have certain rights regarding your personal information, including:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Access to your personal information</li>
                  <li>Correction of inaccurate information</li>
                  <li>Deletion of your information</li>
                  <li>Objection to processing</li>
                  <li>Data portability</li>
                </ul>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">7. Cookies and Tracking</h2>
                <p>
                  We use cookies and similar tracking technologies to track activity on our website and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">8. Children's Privacy</h2>
                <p>
                  Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children under 18.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">9. Changes to This Policy</h2>
                <p>
                  We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold mb-4">10. Contact Us</h2>
                <p>
                  If you have any questions about this Privacy Policy, please contact us at:
                </p>
                <p className="mt-4">
                  <strong>Easy Trademark Filing</strong><br />
                  515 Flower St, 17th Floors<br />
                  Los Angeles, CA 90071<br />
                  United States<br /><br />
                  Email: info@easytrademarkfiling.com<br />
                  Phone: (888) 713-0129
                </p>
              </section>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;